import { render, staticRenderFns } from "./NewIcon.vue?vue&type=template&id=0605ba2e&scoped=true&"
import script from "./NewIcon.vue?vue&type=script&lang=ts&"
export * from "./NewIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0605ba2e",
  null
  
)

export default component.exports